import { baseApi } from './baseApi';
import { CheckUniqueRequest, CheckUniqueResponse, TAG_TYPES } from 'types';

const URL_CHECK_UNIQUE = 'check-unique';
//  BaseUsers, Units, Attributes, TransactionMethods, InventoryOrders, SaleOrders, Suppliers, Categories, Brands, Products"

const checkUniqueApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    checkUnique: builder.mutation<CheckUniqueResponse, CheckUniqueRequest>({
      query: (data) => ({
        url: URL_CHECK_UNIQUE,
        method: 'POST',
        data,
      }),
      invalidatesTags: [{ type: TAG_TYPES.CheckUnique, id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const { useCheckUniqueMutation } = checkUniqueApiService;
